import { computed, defineComponent } from "vue";
import { Container } from "aurelia-dependency-injection";

import { mapState } from "pinia";
import { useApp } from "../../../App/useApp";
import { PermissionManager } from "../../../../common/utilities/permission-manager";
import { ApplicationEnum, ParentPermissionEnum, PermissionActionEnum } from "../../../../enums/enums";
import { IdentityService } from "../../../../services/identity-service";
import { AgencyService } from "../../../../services/agency.service";

import TabsAnimatedHeader from "../../../../resources-vue/vue-custom-elements/TabsAnimatedHeader/TabsAnimatedHeader.vue";
import MessagesPreview from "../../../../resources-vue/vue-custom-elements/MessagingService/MessagesPreview/MessagesPreview.vue";
import GetLiveLoginToken from "../../../../resources-vue/vue-dialogs/GetLiveLoginToken/GetLiveLoginToken.vue";
import UserProfileManagement from "../../../../resources-vue/vue-elements/UserProfileManagement/UserProfileManagement.vue";

type IRoute = {
    path: string;
    name: string;
    meta: {
        menuName: string;
        navItem: string;
    };
};
type ItemRef = {
    [key: string]: Element;
};

export default defineComponent({
    components: {
        TabsAnimatedHeader,
        MessagesPreview,
        UserProfileManagement
    },

    props: {
        router: {},
        showIcons: {
            type: Boolean,
            default: false
        },
        showPatients: {
            type: Boolean,
            default: false
        },
        showEmployees: {
            type: Boolean,
            default: false
        },
        openAgencyNav: {
            type: Boolean,
            default: false
        },
        agenciesList: {
            default: null
        }
    },

    data() {
        return {
            _permissionManager: null,
            _identityService: null,
            _agencyService: null,
            itemRefs: {} as ItemRef,
            showEmployeeSearch: false,
            isAxxessPlannerHeader: false,
            dialogRef: null,
            liveLoginData: null,
            isPathMessaging: false,
            isTestAgency: false,
            isOnlyFamilyPortal: true,
            element: null as HTMLElement,
            showUserStatus: false as boolean
        };
    },

    computed: {
        ...mapState(useApp, ["hasAxxessConnectPermission", "isAnyPremiumAgency", "connectPermissionLoaded"]),
        getActiveItem() {
            return this.element;
        },
        isConnectEnabled() {
            return this.hasAxxessConnectPermission && this.isAnyPremiumAgency;
        },
        connectLockMessage() {
            if (!this.isAnyPremiumAgency) {
                return `Contact Axxess to unlock this <br /> premium Axxess feature.`;
            }
            if (!this.hasAxxessConnectPermission) {
                return `Your organization has turned off Axxess Connect.`;
            }
            return "";
        }
    },

    watch: {
        async $route() {
            this.showUserStatus = this.$route.path.includes("/central-messaging");
        }
    },

    emits: ["update:openAgencyNav", "update:showPatients", "update:showEmployees"],

    async created() {
        this._permissionManager = Container.instance.get(PermissionManager);
        this._identityService = Container.instance.get(IdentityService);
        this._agencyService = Container.instance.get(AgencyService);
        this.isOnlyFamilyPortal = this.agenciesList?.every(
            (resAgency) => resAgency.Application === ApplicationEnum.PatientFamilyPortal
        );
        this.showUserStatus = this.$route.path.includes("/central-messaging");
    },

    async mounted() {
        const employeeInfoViewAcess =
            this._permissionManager.getPermmission(
                ParentPermissionEnum.employeeInformation,
                PermissionActionEnum.canView
            ) || [];
        this.showEmployeeSearch = employeeInfoViewAcess?.length;
        this.liveLoginData = await this._identityService.getLiveLoginToken();
    },

    provide() {
        return {
            dialogRef: computed(() => this.dialogRef)
        };
    },

    methods: {
        addItemRefs(el: Element, route: IRoute) {
            this.itemRefs[route.meta.navItem] = el;
            this.element = this.itemRefs[this.$route.meta.navItem as string] as HTMLElement;
        },

        isActivePath(path: string) {
            if (path.includes("/central-messaging") && window.location.pathname.includes("central-messaging")) {
                this.isPathMessaging = true;

                return true;
            } else if (path === window.location.pathname) {
                this.isPathMessaging = false;

                return true;
            } else {
                return false;
            }
        },

        goTo(path: string) {
            if (path.includes("/central-messaging") && (!this.isAnyPremiumAgency || !this.hasAxxessConnectPermission)) {
                return;
            }
            this.$router.push(path);
        },

        toggleEmployeesMenus() {
            this.$emit("update:showEmployees", !this.showEmployees);
            if (this.showPatients) {
                this.$emit("update:showPatients", false);
            }
        },
        togglePatientsMenu(): void {
            this.$emit("update:showPatients", !this.showPatients);
            if (this.showEmployees) {
                this.$emit("update:showEmployees", false);
            }
        },

        async displayLiveLoginToken() {
            let response = this.liveLoginData;
            this.dialogRef = this.$dialog.open(GetLiveLoginToken, {
                props: {
                    modal: true,
                    showHeader: false
                },
                data: {
                    response
                }
            });
        },

        showRoute(routeName: string) {
            if (routeName === "tabMessaging") {
                if (!this.isOnlyFamilyPortal) {
                    return true;
                } else {
                    return false;
                }
            } else {
                return true;
            }
        },

        toggleAsideNav(): void {
            this.$emit("update:openAgencyNav", !this.openAgencyNav);
        }
    }
});
